import React, {useCallback, useMemo} from 'react';
import cn from 'classnames';

import {isProductSearchHitModel} from 'coreClasses/search/ProductSearchHitModel';
import Skeleton from 'coreComponents/Skeleton';
import useLocation from 'coreHooks/useLocation';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import ProductName from 'brandComponents/product/ProductName';
import {QUICK_SEARCH_FLYOUT_ID} from 'brandConstants';
import {useProductName} from 'brandHooks';

import {useProductHitContext} from '../../ProductHitContext';

import {IProductHitName} from './IProductHitName';

import styles from './ProductHitName.module.scss';

const ProductHitName = ({
	classNames,
	onClick,
	as = 'p',
	pushDataLayerClickEvent = true,
	source,
	sourceSpecification,
	disableLink = false,
}: IProductHitName) => {
	const {product, position, dataLayerEventOnClick} = useProductHitContext();
	const {managerRepository} = useGeneralProvider();
	const location = useLocation();

	const productNameInfo = useProductName(product?.getName());

	const url = useMemo(() => {
		if (!product || disableLink) {
			return undefined;
		}

		if (isProductSearchHitModel(product)) {
			return product.getUrl();
		}

		return product.getProductUrl();
	}, [product, disableLink]);

	const handleClick = useCallback(() => {
		if (!isProductSearchHitModel(product) && pushDataLayerClickEvent) {
			dataLayerEventOnClick(product, position, source, sourceSpecification);
		}

		if (product.getProductUrl() === location.pathname) {
			managerRepository.getFlyoutsMgr().closeFlyout(QUICK_SEARCH_FLYOUT_ID);
		}

		onClick?.();
	}, []);

	return (
		<div className={cn(styles['product-hit__name'], 'product-hit__name', classNames?.wrapper)}>
			<ProductName url={url} onClick={handleClick} as={as} classNames={cn(classNames?.name)}>
				{product && <>{productNameInfo.name}</>}

				{!product && <Skeleton width="100%" height="24px" />}
			</ProductName>
		</div>
	);
};

export default ProductHitName;
